import axios from 'axios';

const apiService = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 5000
});

export default apiService;